var lastScrollTop = 120;

$(window).scroll(function(event){
  var header = $('div[data-section-id="header"]');
  var ctaBanner = $('.product-actions-sticky');
  var fixPosition = $(header).height();
  var st = $(this).scrollTop();
  
  if (st > lastScrollTop){
    $(header).css('top', -fixPosition);
    //$(ctaBanner).css('bottom', '0');;
  } else if (st < fixPosition + 20) {
    return null;
  } else {
    $(header).css('top', '0');
    //$(ctaBanner).css('bottom', -fixPosition);
  }
  lastScrollTop = st;
  
  if (st > fixPosition){
    $(header).css('position', 'fixed');
    $('body').css('padding-top', fixPosition);
    //$(ctaBanner).css('top', '0');
  } else if (st = 0){
    $(header).css('position', 'initial');
    $('body').css('padding-top','0');
    //$(ctaBanner).css('top', '-75');
  }
});

$(document).ready(function() {
  $('.product-template__custom .bullet_discover a').on('click', function(evt) {
    evt.preventDefault();
    $('html, body').animate(
      { scrollTop: $($(this).attr('href')).offset().top - 60},
      800
    );
  });
  
  $('.product-template__custom .bullet_moredetails a').on('click', function(evt) {
    evt.preventDefault();
    $('html, body').animate(
      { scrollTop: $($(this).attr('href')).offset().top - 60},
      800
    );
  });
  
  $('.product-template__custom .product-single__meta-price__reward a').on('click', function(evt) {
    evt.preventDefault();
    $('html, body').animate(
      { scrollTop: $($(this).attr('href')).offset().top - 60},
      800
    );
  });
  
  $('a.anchor-video').on('click', function(evt) {
    evt.preventDefault();
    $('html, body').animate(
      { scrollTop: $($(this).attr('href')).offset().top - 60},
      800
    );
  });
  
  $('.product-template__custom .product-actions .product_btn-discover a').on('click', function(evt) {
    evt.preventDefault();
    $('html, body').animate(
      { scrollTop: $($(this).attr('href')).offset().top },
      800
    );
  });

  
  //$('.btnTriggerProduct').trigger('click', function(){
  	//$('.product-actions-nochange .shopify-payment-button__button').click();
  //});
  
  
  if (window.location.href.indexOf("products") > -1) {
	$(window).scroll(function (event) {

      //var header = $('div[data-section-id="header"]');
      var Cta = $('.product-actions-nochange');
      //var CtaButton = $('.product-actions-nochange .btn');
      var CtaSticky = $('.product-actions-sticky');
      var posCta = Cta.position().top + 150;
      var winScroll = $(window).scrollTop();
      //var fixPosition = $(header).height();

      if(winScroll > posCta){
        //$(CtaButton).hide();
        $(CtaSticky).addClass('stickyBanner');
      } else {
        //$(CtaButton).show();
        //$(CtaSticky).css('bottom', -fixPosition);
        $(CtaSticky).removeClass('stickyBanner');
        //$(CtaSticky).removeClass('isActive');
      }

    });
  }
});

var $form = $('.airtableForm');

function validateEmail(email) {
	var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return regex.test(email);
};

$form.on('keyup', 'input', function(e) {
	var $this = $(this),
		$input = $this.val();
	if ($input.length > 0) {
		$form.find('label').addClass('active');
		if (validateEmail($input)) {
			$form.find('button').addClass('active');
			//console.log(e);
			if (e.which === 13) {
				$form.find('button').click();
				$this.blur();
			}
		} else {
			$form.find('button').removeClass('active');
		}
		$(this).addClass('active');
	} else {
		$form.find('label').removeClass('active');
		$form.find('button').removeClass('active');
		$(this).removeClass('active');
	}
});

$form.on('click', 'button.active', function(e) {
	e.preventDefault;
	var $this = $(this);
  	var $alertSuccess = $('.product_alert_success');
	//$(this).addClass('full');
	//$(this).html('Thanks!');
  	$alertSuccess.addClass('active');

	setTimeout(()=> {
		$form.find('input').val('').removeClass('active');
		$form.find('label').removeClass('active');
		$this.removeClass('full active');
  		$alertSuccess.removeClass('active');
		//$this.html('OK');
	}, 1200);
});



$(document).ready(function() {
  var $videoSectionBtn = $('#shopify-section-product-video .btn.video-control.video-control__play');
  var $iframeVideo = $('#shopify-section-product-video #Video-product-video');
  
  if (window.location.href.indexOf("#shopify-section-product-video") > -1) {
    setTimeout(()=> {
      $($videoSectionBtn).click();
	}, 2000);
  
  }
});

$(document).ready(function() {
  var $videoSectionBtn = $('#shopify-section-product-it-video .btn.video-control.video-control__play');
  var $iframeVideo = $('#shopify-section-product-it-video #Video-product-video');
  
  if (window.location.href.indexOf("#shopify-section-product-it-video") > -1) {
    setTimeout(()=> {
      $($videoSectionBtn).click();
	}, 2000);
  
  }
});

$(document).ready(function() {
  $('.smooth-scroll').on('click', function(evt) {
    evt.preventDefault();
    $('html, body').animate(
      { scrollTop: $($(this).attr('href')).offset().top},
      300
    );
  });
});

$(document).ready(function() {
  $('.btn-open-modal').on('click', function(e) {
    e.preventDefault();
    $('.cart-note-modal').css('display','flex');
  });
  
  $('.cart-note-modal-close').on('click', function(e) {
    e.preventDefault();
    $('.cart-note-modal').css('display','none');
  });
});


//------------------------------------------------
/* Joyeuse V2 - Refonte */
//------------------------------------------------

$(document).ready(function() {
  $('.open-menu-sidebar').on('click', function(e) {
    e.preventDefault();
    $('html, body').css('overflow','hidden');
    
    $('.sidebar--nav').css('left','0');
    
    $('.sidebar--nav-overlay').css('display','block');
    setTimeout(function(){
      $('.sidebar--nav-overlay').css('opacity','1');
    }, 50);
    
    /*if ($(window).width() > 520) {
      
    }*/
  });
  
  $('.close-menu-sidebar').on('click', function(e) {
    e.preventDefault();
    $('html, body').css('overflow','auto');
    
    $('.sidebar--nav').css('left','-520px');
    
    $('.sidebar--nav-overlay').css('opacity','0');
    setTimeout(function(){
      $('.sidebar--nav-overlay').css('display','none');
    }, 250);
  });
  
  $('.sidebar--nav-overlay').on('click', function(e) {
    e.preventDefault();
    $('html, body').css('overflow','auto');
    
    $('.sidebar--nav').css('left','-520px');
    
    $('.sidebar--nav-overlay').css('opacity','0');
    setTimeout(function(){
      $('.sidebar--nav-overlay').css('display','none');
    }, 250);
  });
  
});
  
var theLastScrollTop = 120;

$(window).scroll(function(event){
  var headerV2 = $('#shopify-section-header-v2');
  var fixPosition2 = $(headerV2).height();
  var windowHeight = $(window).height();
  var st2 = $(this).scrollTop();

  if (st2 > fixPosition2 / 2){
    $(headerV2).css('background-color', '#ffffff');
    $('#shopify-section-header-v2 .site-header__logo').addClass('marginFixed');
    $('#shopify-section-header-v2 .site-header--sidebar').addClass('headerFixed');
  } else if (st2 === 0){
    $(headerV2).css('background-color', 'transparent');
    $('#shopify-section-header-v2 .site-header__logo').removeClass('marginFixed');
    $('#shopify-section-header-v2 .site-header--sidebar').removeClass('headerFixed');
  }

  if (st2 > windowHeight / 2){
    if (st2 > theLastScrollTop){
      $(headerV2).css('top', -fixPosition2);
      $('#dropdownClubList').css('display', 'none');
    } else if (st2 < fixPosition2 + 20) {
      return null;
    } else {
      $(headerV2).css('top', '0');
    }
  }
  
  
  theLastScrollTop = st2;
});

var theLastScrollTop2 = 120;

// $(window).scroll(function(event){
//   var headerInline = $('#shopify-section-header-inline');
//   var fixPosition2 = $(headerInline).height();
//   var windowHeight = $(window).height();
//   var st2 = $(this).scrollTop();

//   if (st2 > windowHeight / 2){
//     if (st2 > theLastScrollTop2){
//       $(headerInline).css('top', -fixPosition2);
//     } else if (st2 < fixPosition2 + 20) {
//       return null;
//     } else {
//       $(headerInline).css('top', '0');
//     }
//   }
  
  
//   theLastScrollTop2 = st2;
// });

// Assistance Tutoriel
function scrollSmoothToBottom (id) {
  var windowSize = $(window).width();
  var div = document.getElementById(id);
  
  if(windowSize <= 849){
  	$('#' + id).animate({
      scrollLeft: -(div.scrollWidth - div.scrollLeft)
    }, 500);
  } else {
    $('#' + id).animate({
      scrollTop: div.scrollHeight - div.clientHeight
    }, 500);
  }
}

function scrollSmoothToTop (id) {
  var windowSize = $(window).width();
  var div = document.getElementById(id);
  
  if(windowSize <= 849){
  	$('#' + id).animate({
      scrollLeft: div.scrollWidth - div.scrollLeft
    }, 500);
  } else {
    $('#' + id).animate({
      scrollTop: -(div.scrollHeight - div.clientHeight)
    }, 500);
  }
}

$(document).ready(function() {
  $('#assistanceVideoList').scroll(function(event){
    var windowSize = $(window).width();
    var listPos = $(this).scrollTop();
    var listHeight = $(this)[0].clientHeight;
    var listRealHeight = $(this)[0].scrollHeight;
    var buttonUp = $('#assistanceVideoArrowUp');
    var buttonDown = $('#assistanceVideoArrowDown');
    
    if(windowSize > 849){
      if(listPos < 10){
        $(buttonUp).css('opacity', '0.2');
      } else {
        $(buttonUp).css('opacity', '1');
      }

      if(listPos > ((listRealHeight - listHeight) - 10)){
        $(buttonDown).css('opacity', '0.2');
      } else {
        $(buttonDown).css('opacity', '1');
      }
    }
  });
  
  
  $('.assistance-video2 .assistance-video--main_list-item').click(function(){
    var elVideoTitle = $('.assistance-video2 .assistance-video--video-title');
    var elVideo = $('.assistance-video2 .assistance-video--video');
    var elVideoText = $('.assistance-video2 .assistance-video--text');
    
  	var currentItemData = $(this).attr('data-video-item');
  	var currentElVideoTitle = $(elVideoTitle).find(`[data-video-item='${currentItemData}']`);
  	var currentElVideo = $(elVideo).find(`[data-video-item='${currentItemData}']`);
  	var currentElVideoText = $(elVideoText).find(`[data-video-item='${currentItemData}']`);
    
    $(elVideoTitle).addClass('video-desactive');
    $(elVideoTitle).removeClass('video-active');
    $(elVideo).addClass('video-desactive');
    $(elVideo).removeClass('video-active');
    $(elVideoText).addClass('video-desactive');
    $(elVideoText).removeClass('video-active');
    
    $(`[data-video-item=${currentItemData}]`).addClass('video-active');
    $(`[data-video-item=${currentItemData}]`).removeClass('video-desactive');
    
    $('.assistance-video2 .video-control__close-wrapper').click();
    
    $('.assistance-video2 .assistance-video--main_list-item').removeClass('video-active').addClass('video-desactive');
    $(this).addClass('video-active').removeClass('video-desactive');
  });
});

$(document).ready(function () { 
  var cube = $('.shake-v2-custom--body-cube .cube');
  
  var arrowTop = $('.shake-v2-custom--body-cube .shake-v2--cube-arrow--top');
  var arrowRight = $('.shake-v2-custom--body-cube .shake-v2--cube-arrow--right');
  var arrowBottom = $('.shake-v2-custom--body-cube .shake-v2--cube-arrow--bottom');
  var arrowLeft = $('.shake-v2-custom--body-cube .shake-v2--cube-arrow--left');
  
  var faceFront = $('.shake-v2-custom--body-faces-item.face-front');
  var faceBack = $('.shake-v2-custom--body-faces-item.face-back');
  var faceRight = $('.shake-v2-custom--body-faces-item.face-right');
  var faceLeft = $('.shake-v2-custom--body-faces-item.face-left');
  var faceTop = $('.shake-v2-custom--body-faces-item.face-top');
  var faceBottom = $('.shake-v2-custom--body-faces-item.face-bottom');
  
  arrowTop.click(function(){
    if(cube.hasClass('show-front')){
      faceTop.click();
    } else if(cube.hasClass('show-back')){
      faceBottom.click();
    } else if(cube.hasClass('show-right')){
      faceTop.click();
    } else if(cube.hasClass('show-left')){
      faceTop.click();
    } else if(cube.hasClass('show-top')){
      faceBack.click();
    } else if(cube.hasClass('show-bottom')){
      faceFront.click();
    }
  });
  
  arrowRight.click(function(){
    if(cube.hasClass('show-front')){
      faceRight.click();
    } else if(cube.hasClass('show-back')){
      faceLeft.click();
    } else if(cube.hasClass('show-right')){
      faceBack.click();
    } else if(cube.hasClass('show-left')){
      faceFront.click();
    } else if(cube.hasClass('show-top')){
      faceRight.click();
    } else if(cube.hasClass('show-bottom')){
      faceRight.click();
    }
  });
  
  arrowBottom.click(function(){
    if(cube.hasClass('show-front')){
      faceBottom.click();
    } else if(cube.hasClass('show-back')){
      faceTop.click();
    } else if(cube.hasClass('show-right')){
      faceBottom.click();
    } else if(cube.hasClass('show-left')){
      faceBottom.click();
    } else if(cube.hasClass('show-top')){
      faceFront.click();
    } else if(cube.hasClass('show-bottom')){
      faceBack.click();
    }
  });
  
  arrowLeft.click(function(){
    if(cube.hasClass('show-front')){
      faceLeft.click();
    } else if(cube.hasClass('show-back')){
      faceRight.click();
    } else if(cube.hasClass('show-right')){
      faceFront.click();
    } else if(cube.hasClass('show-left')){
      faceBack.click();
    } else if(cube.hasClass('show-top')){
      faceLeft.click();
    } else if(cube.hasClass('show-bottom')){
      faceLeft.click();
    }
  });
  
});

$(document).ready(function () { 
  var cube2 = $('.shake-v2-custom--body-cube2 .cube2');
  
  var arrowTop2 = $('.shake-v2-custom--body-cube2 .shake-v2--cube-arrow--top');
  var arrowRight2 = $('.shake-v2-custom--body-cube2 .shake-v2--cube-arrow--right');
  var arrowBottom2 = $('.shake-v2-custom--body-cube2 .shake-v2--cube-arrow--bottom');
  var arrowLeft2 = $('.shake-v2-custom--body-cube2 .shake-v2--cube-arrow--left');
  
  var faceFront2 = $('.shake-v2-custom--body-faces-item2.face-front');
  var faceBack2 = $('.shake-v2-custom--body-faces-item2.face-back');
  var faceRight2 = $('.shake-v2-custom--body-faces-item2.face-right');
  var faceLeft2 = $('.shake-v2-custom--body-faces-item2.face-left');
  var faceTop2 = $('.shake-v2-custom--body-faces-item2.face-top');
  var faceBottom2 = $('.shake-v2-custom--body-faces-item2.face-bottom');
  
  arrowTop2.click(function(){
    if(cube2.hasClass('show-front')){
      faceTop2.click();
    } else if(cube2.hasClass('show-back')){
      faceBottom2.click();
    } else if(cube2.hasClass('show-right')){
      faceTop2.click();
    } else if(cube2.hasClass('show-left')){
      faceTop2.click();
    } else if(cube2.hasClass('show-top')){
      faceBack2.click();
    } else if(cube2.hasClass('show-bottom')){
      faceFront2.click();
    }
  });
  
  arrowRight2.click(function(){
    if(cube2.hasClass('show-front')){
      faceRight2.click();
    } else if(cube2.hasClass('show-back')){
      faceLeft2.click();
    } else if(cube2.hasClass('show-right')){
      faceBack2.click();
    } else if(cube2.hasClass('show-left')){
      faceFront2.click();
    } else if(cube2.hasClass('show-top')){
      faceRight2.click();
    } else if(cube2.hasClass('show-bottom')){
      faceRight2.click();
    }
  });
  
  arrowBottom2.click(function(){
    if(cube2.hasClass('show-front')){
      faceBottom2.click();
    } else if(cube2.hasClass('show-back')){
      faceTop2.click();
    } else if(cube2.hasClass('show-right')){
      faceBottom2.click();
    } else if(cube2.hasClass('show-left')){
      faceBottom2.click();
    } else if(cube2.hasClass('show-top')){
      faceFront2.click();
    } else if(cube2.hasClass('show-bottom')){
      faceBack2.click();
    }
  });
  
  arrowLeft2.click(function(){
    if(cube2.hasClass('show-front')){
      faceLeft2.click();
    } else if(cube2.hasClass('show-back')){
      faceRight2.click();
    } else if(cube2.hasClass('show-right')){
      faceFront2.click();
    } else if(cube2.hasClass('show-left')){
      faceBack2.click();
    } else if(cube2.hasClass('show-top')){
      faceLeft2.click();
    } else if(cube2.hasClass('show-bottom')){
      faceLeft2.click();
    }
  });
  
});

$(document).ready(function () { 
  var CubeContentCm = $('.shake-v2-custom--body.tab-content-cm');
  var CubeIntroCm = $('.shake-v2-custom--head-title.tab-intro-cm');
  var CubeContentMpc = $('.shake-v2-custom--body2.tab-content-mpc');
  var CubeIntroMpc = $('.shake-v2-custom--head-title.tab-intro-mpc');
  var CubeTabCm = $('.shake-v2-custom .shake-v2-custom--head #tabShakeCm');
  var CubeTabMpc = $('.shake-v2-custom .shake-v2-custom--head #tabShakeMpc');
  
  $(CubeTabCm).click(function(){
    if($(this).hasClass('active-tab')){
    
    } else {
      $(this).addClass('active-tab');
      $(CubeTabMpc).removeClass('active-tab');
      $(CubeContentMpc).hide();
      $(CubeIntroMpc).hide();
      $(CubeContentCm).show();
      $(CubeIntroCm).show();
    }
  });
  $(CubeTabMpc).click(function(){
    if($(this).hasClass('active-tab')){
    
    } else {
      $(this).addClass('active-tab');
      $(CubeTabCm).removeClass('active-tab');
      $(CubeContentCm).hide();
      $(CubeIntroCm).hide();
      $(CubeContentMpc).show();
      $(CubeIntroMpc).show();
    }
  });
});

/* MENU BOUTON DROPDOWN CLUB */
$(document).ready(function () { 
  $("#dropdownClub").click(function(){
    $("#dropdownClubList").toggleClass('activeToggle');
  });
});

//$(document).mouseup(function(e) {
//  var container = $("#dropdownClubList");
//  if (!container.is(e.target) && 
//      container.has(e.target).length === 0 && 
//      container.hasClass('activeToggle') ) {
//    $(container).removeClass('activeToggle');
//  }
//});

/* E-Digital Product - Show/Hide variant information in product */
$(document).ready(function () { 
  var variantItem = $('.product-variant_item'); 
  var variantItemClick = $('.product-form__variants-list .product-variant_item .product-variant_title');
  var variantInfo = $('.product-variant_description');
  var elShowVariantDescription = $('.product-form__variants-list .product-variant_item .showVariantDescription');
  
  $(variantItemClick).click(function(){
    $(this).closest(variantItem).find(variantInfo).toggleClass('show');
    $(this).closest(variantItem).find(elShowVariantDescription).toggleClass('active');	
  });
});

$(document).ready(function () { 
  /* PLAY AUDIO PREVIEW ON RECOMMENDATION SECTION */
  $('.listenRecoPreview').click(function() {
    var variantId = $(this).data('variant-id');
    var buttonTarget = $('#listenRecoPreview-' + variantId);
    var previewTarget = $('#audioRecoPreview-' + variantId);
    
    if (buttonTarget.hasClass('active')) {
      previewTarget.trigger("pause");
      buttonTarget.removeClass('active');
    } else {
      $('.listenRecoPreview').removeClass('active');
      $('.audioRecoPreview').trigger("pause");
      previewTarget.trigger("play");
      buttonTarget.addClass('active');
    }
  });
  
  /* PLAY AUDIO PREVIEW ON PRODUCT PAGE */
  $('.listenPreview').click(function() {
    var variantId = $(this).data('variant-id');
    var buttonTarget = $('#listenPreview-' + variantId);
    var previewTarget = $('#audioPreview-' + variantId);
    
    if (buttonTarget.hasClass('active')) {
      previewTarget.trigger("pause");
      buttonTarget.removeClass('active');
    } else {
      $('.listenPreview').removeClass('active');
      $('.audioPreview').trigger("pause");
      previewTarget.trigger("play");
      buttonTarget.addClass('active');
    }
  });
  
  /* ADD PRODUCT TO CART ON COLLECTION PAGE */
  $('.quickadd-collection-product').click(function() {

    var product_url = $(this).data('url');
    var product_id = $(this).data('variantid');

    //alert(product_id);
    jQuery.getJSON(product_url + '.js', function(product){

      jQuery.post('/cart/add.js', {
        quantity: 1,
        id: product_id
      });
    });
  });
  
});

/* Algolia collection page - Filter dropdown select2 */
$(document).ready(function () { 
  
  $('.ais-page .ais-facet--header').click(function() {
  
    if ($(this).hasClass('active')) {
      $(this).toggleClass('active');
    }else if ($('.ais-page .ais-facet--header').find('.active')) {
      $('.ais-page .ais-facet--header.active').toggleClass('active');
      $(this).toggleClass('active');
    } else {
      $(this).toggleClass('active');
    }
    
  });

  $(document).on("click",function(event){
    if(!$(event.target).closest(".ais-page .ais-facet--header").length){
      $(".ais-page .ais-facet--header").removeClass("active");
    }
  });
  
});

/* E-Product page - Description button - Show more information */
$(document).ready(function () { 
  
  $('#showDescriptionEproduct').click(function() {
    $('.product-single__description').toggleClass('active');
  });
  
});

/* Cart Page - Open modal */
$(document).ready(function () { 
  
  $('.openModalVerification').click(function() {
    $('.modal_verify').show();
  });
  
  $('.modal_verify .modal_verify_btn').click(function() {
    $('.cart__trigger').trigger('click');
  });
  
  $('.modal_verify .modal_verify_overlay').click(function() {
    $('.modal_verify').hide();
  });
  
});


/* Header Inline Menu - Dropdown account */
$(document).ready(function () { 
  const accountDropdown = document.querySelector('#myDropdownAccount');
  const accountButton = document.querySelector('#myButtonAccount');

  if (document.getElementById('myDropdownAccount')) {
    window.addEventListener('click', function(e){   
      if (document.getElementById('myDropdownAccount').contains(e.target)){
        // Clicked in box
      } else if (document.getElementById('myButtonAccount').contains(e.target)) {
        // Clicked in button
      } else {
        if ($(accountDropdown).find('.show')){
          // Clicked outside the box
          $(accountDropdown).removeClass("show");
        } 
      }
      e.stopPropagation(); 
    });
  }
  
  /* When the user clicks on the button,
  toggle between hiding and showing the dropdown content */
  $(accountButton).click(function() {
    if ($(accountDropdown).hasClass("show")){
      $(accountDropdown).removeClass("show");
    } else {
      $(accountDropdown).addClass("show");
    }
  });
  
});


$(document).ready(function(){
  const swiperButtonPrev = $('.product-template__custom .swiper-button-prev');
  const swiperButtonNext = $('.product-template__custom .swiper-button-next');

  $(swiperButtonPrev).click(function(e) {
    $('.product-template__custom .swiper-slide .active-thumb').parents('li.swiper-slide').prev('li.swiper-slide').children('a').click();
  });
  $(swiperButtonNext).click(function(e) {
    $('.product-template__custom .swiper-slide .active-thumb').parents('li.swiper-slide').next('li.swiper-slide').children('a').click();
  });
});


$(document).ready(function(){
  const productHead = document.querySelector('#productHeader');
  const productPhoto = document.querySelector('#productPhoto');
  
  const resizeObserver = new ResizeObserver(entries => {
    if ($(window).width() > 970) {
      productPhoto.setAttribute("style","margin-top : -" + entries[0].target.clientHeight + "px");
    } else {
      productPhoto.setAttribute("style","margin-top : 0px");
    }
  })
  
  if (window.location.href.indexOf("products") > -1) {
    resizeObserver.observe(productHead)
  }

  //Manage Product select and radio variant during changing process
  const selectVariant = document.querySelector('#productVariantSelectEl');
  
  const changeSelectVariantOptions = (e) => {
    const currentSelectValue = $(selectVariant).val();
    
    const optionVariant = $('#productVariantSelectEl option:selected');
    const optionVariantVal = $(optionVariant).val();
    const optionVariantID = $(selectVariant).find('option[value="' + optionVariantVal + '"]').attr('id');
    const optionVariantIDRework = optionVariantID.replace('productVariantOption-', '');
    
    const imageOptionVariant = $('.productVariantTypeSelectWrapper img');
    const imageOptionVariantTarget = $('#productImageVariantOption-' + optionVariantIDRework);

    $(selectVariant).find('option[selected="selected"]').removeAttr("selected", "selected");
    $(selectVariant).find('option[value="' + currentSelectValue + '"]').attr("selected", "selected");
    $(imageOptionVariant).css('display', 'none');
    $(imageOptionVariantTarget).css('display', 'block');
  };

  $(selectVariant).on('change', function(){
    changeSelectVariantOptions();
  });
  
  const radioVariant = $('.productVariantOptionRadio')
  const changeRadioVariantOptions = (e) => {
    const currentRadioValue = $('.productVariantOptionRadio:checked').val();
    $(selectVariant).val(currentRadioValue).trigger('change');
    
    const selectVariantVall = $(selectVariant).val();
  };

  $(radioVariant).on('change', function(){
    changeRadioVariantOptions();
  });
});


$(document).ready(function(){
  const veepeeRadio = $('.veepeeInputRadio');
  const veepeeButton = $('#veepeeButton');
  const veepeetriggerButton = $('#triggerCta');
  const promoteContainer = $('.promote-veepee-body-conteuse');
  const promoteInfoMPC = $('#promoteInfoMPC');
  const promoteImgSacocheLCM = $('#promoteInfoMPC .img-sacoche-lcm');
  const promoteImgSacocheMPC = $('#promoteInfoMPC .img-sacoche-mpc');
  const promoteImgPriceLCMUK = $('#promoteInfoMPC .price-lcmuk');
  const promoteImgPriceMPC = $('#promoteInfoMPC .price-mpc');
  
  const changeHrefButton = (e) => {
    const currentRadioValue = $('.veepeeInputRadio:checked').val();
    
    if (currentRadioValue === 'mpc') {
      $(veepeeButton).attr("href", "https://www.joyeuse.io/products/offre-showroom-ma-premiere-conteuse-et-son-album");
      $(veepeetriggerButton).attr("href", "https://www.joyeuse.io/products/offre-showroom-ma-premiere-conteuse-et-son-album");
      
      $(promoteImgSacocheLCM).hide();
      $(promoteImgPriceLCMUK).hide();
      $(promoteImgSacocheMPC).show();
      $(promoteImgPriceMPC).show();
      
      $(promoteContainer).removeClass('active');
      $('.veepeeInputRadio:checked').parents('div').addClass('active');
    }
    if (currentRadioValue === 'lcm') {
      $(veepeeButton).attr("href", "https://www.joyeuse.io/products/offre-showroom-la-conteuse-merveilleuse-et-son-album-de-noel");
      $(veepeetriggerButton).attr("href", "https://www.joyeuse.io/products/offre-showroom-la-conteuse-merveilleuse-et-son-album-de-noel");

      $(promoteImgSacocheMPC).hide();
      $(promoteImgPriceLCMUK).hide();
      $(promoteImgSacocheLCM).show();
      $(promoteImgPriceMPC).show();
      
      $(promoteContainer).removeClass('active');
      $('.veepeeInputRadio:checked').parents('div').addClass('active');
    }
    if (currentRadioValue === 'lcm_uk') {
      $(veepeeButton).attr("href", "https://www.joyeuse.io/products/offre-showroom-la-conteuse-japprends-langlais-edlimitee-et-son-album-de-noel");
      $(veepeetriggerButton).attr("href", "https://www.joyeuse.io/products/offre-showroom-la-conteuse-japprends-langlais-edlimitee-et-son-album-de-noel");
      
      $(promoteImgSacocheMPC).hide();
      $(promoteImgPriceMPC).hide();
      $(promoteImgSacocheLCM).show();
      $(promoteImgPriceLCMUK).show();
      
      $(promoteContainer).removeClass('active');
      $('.veepeeInputRadio:checked').parents('div').addClass('active');
    }
  };

  $(veepeeRadio).on('change', function(){
    changeHrefButton();
  });



  $(".sliding-veepee").click(function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top - 100},'slow');
  });


  const videoWrapper = $('.video-veepee .videoVeepeeWrapper');
  const videoButton = $('.video-veepee .videoVeepeeWrapper .buttonPlayVideo');
  const videoPlayer = $('.video-veepee .videoVeepeeWrapper video.videoPlayerClass');
  const videoPlayerSource = $('.video-veepee .videoVeepeeWrapper video.videoPlayerClass source');
  const videoImage = $('.grid__item-video img.imageCover');
  const videoButtonWrapper = $('.videoVeepeeWrapper-btn');

  $(videoButtonWrapper).click(function(e) {
    if($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).prev(videoPlayer).get(0).pause();
    } else {
      $(this).addClass('active');
      //$(this).prev('video.videoPlayerClass').css('object-fit', 'contain');
      $(this).prev('video.videoPlayerClass').attr("controls", "controls");
      var currentVideoSource = $(this).prev('video.videoPlayerClass').children('source').attr('native-src');
      $(this).prev('video.videoPlayerClass').children('source').removeAttr('native-src');
      $(this).prev('video.videoPlayerClass').children('source').attr('src', currentVideoSource);
      $(this).prev(videoPlayer).load();
      $(this).prev(videoPlayer).get(0).play();
    }
  });

  $(videoPlayer).on('play', function() {
    const videoBlockWrapper = $(this).parents('.videoVeepeeWrapper').parents('.grid__item-video');
    const videoButtonWrapper = $(this).next('.videoVeepeeWrapper-btn');
    $(videoButtonWrapper).addClass('active');
    $(videoBlockWrapper).addClass('active');
  });
  
  $(videoPlayer).on('pause', function() {
    const videoBlockWrapper = $(this).parents('.videoVeepeeWrapper').parents('.grid__item-video');
    const videoButtonWrapper = $(this).next('.videoVeepeeWrapper-btn');
    
    $(videoButtonWrapper).removeClass('active');
    $(videoBlockWrapper).removeClass('active');
  });

});








